import { render, staticRenderFns } from "./PaymentNewsletter.vue?vue&type=template&id=37e8040f&"
import script from "./PaymentNewsletter.vue?vue&type=script&lang=js&"
export * from "./PaymentNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports